query DisputesList($page: Int, $rowsPerPage: Int, $filter: JSON) {
  disputes(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      organizationId
      amount {
        value
        currency
        valueUSD
      }
      ottkitFeeAmount {
        valueUSD
      }
      organizationAmount {
        valueUSD
      }
      status
      createdAt
      closedAt
      organization {
        title
      }
      payment {
        userId
        buyerEmail
        provider
        product {
          title
          type
        }
      }
    }
  }
}
